export const DEFAULT_APPBAR_HEIGHT = '56px';
